import { ReactNode } from "react"
import { store } from "./stores"
import { client } from "@/hooks/useClient"
import { endpoints } from "@/config/endpoints.config"

export interface AppStore {
  editingAvatar: boolean
  confirmModal?: {
    opened?: boolean
    title: string
    children?: ReactNode
    onConfirm: () => Promise<any>
    danger?: boolean
  } | null
  loaded: boolean
  settingsModal?: boolean
  modals?: { id: string; component: ReactNode }[]
  actions: {
    openConfirmModal: (props: AppStore["confirmModal"]) => void
    openSettingsModal: () => void
    addModal: (key: string, component: ReactNode) => void
    removeModal: (key: string) => void
    closeSettingsModal: () => void
    upload: (dto: { file: File; }) => Promise<{
      url: string
      key: string
      contentType: string
      publicUrl: string
    }>
  }
}

export const appStore: AppStore = {
  editingAvatar: false,
  confirmModal: null,
  loaded: false,
  modals: [],

  actions: {
    openConfirmModal: (props) => {
      store.app.confirmModal = {
        ...props!,
        opened: true,
      }
    },
    addModal: (key, component) => {
      store.app.modals = [...(store.app.modals || []), { id: key, component }]
    },
    removeModal: (key) => {
      store.app.modals = store.app.modals?.filter((modal) => modal.id !== key)
    },
    openSettingsModal: () => {
      store.app.settingsModal = true
    },
    closeSettingsModal: () => {
      store.app.settingsModal = false
    },
    upload: async (dto: { file: File }) => {
      // const formData = new FormData()
      // formData.append("file", file)
      const response = await client.post(endpoints.GET_UPLOAD_PRESIGNED_URL, {
        filename: dto.file.name,
        contentType: dto.file.type,
        expiresIn: 3600, // 1 hora
      })

      const { url, key, contentType } = response.data

      // Fazer upload diretamente para o S3
      const uploadResponse = await fetch(url, {
        method: 'PUT',
        headers: {
          "Content-Type": contentType,
          'Cache-Control': 'public,max-age=31536000,immutable',
          'x-amz-acl': 'public-read'
        },
        body: dto.file,
      })

      // console.log("uploadResponse", key, url, contentType)

      if (!uploadResponse.ok) {
        throw new Error("Error on upload")
      }

      return response.data
    },
  },
}
